import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import * as serviceWorker from './serviceWorker';
import PieroSsoSupport from './piero-sso-support'
import App from './App';

// Sentry.init({
//     dsn: "https://b290f38620c64526b416803e788cb654@o555353.ingest.sentry.io/5685062",
//     integrations: [new Integrations.BrowserTracing()],
  
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
// });

PieroSsoSupport.processTicketIfPresent().then(redirect => {
    console.log('Visura ticket Is Present')
    if (redirect) {
        window.location.replace('/')
    }
}).finally(() => {
    ReactDOM.render(<App />, document.getElementById('root'));

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
})
